module.exports = __webpack_public_path__ + "img/Federale_nl_logo.7ffdd792.png";